import {
  buildTeammateDisplayNames,
  type BasicTeammate,
} from "@repo/app-types/entities/teammate";
import { skeletonStyle } from "@repo/ui/Skeletons/skeletons";
import type { FC } from "react";

interface TeammateNameStackProps {
  teammate: BasicTeammate | null | undefined;
  // Render a skeleton in the primary slot while the teammate is being fetched.
  // Callers with a pre-resolved teammate omit this.
  isLoading?: boolean;
}

export const TeammateNameStack: FC<TeammateNameStackProps> = (props) => {
  const displayNames = props.teammate
    ? buildTeammateDisplayNames(props.teammate)
    : undefined;

  if (displayNames === undefined && !props.isLoading) return null;

  return (
    <>
      <div className="flex items-center gap-2">
        <span className="w-[10rem] max-w-fit flex-auto truncate font-medium">
          {displayNames === undefined && props.isLoading ? (
            <span
              className={skeletonStyle({ className: "inline-block h-5 w-32" })}
            />
          ) : null}
          {displayNames?.primaryDisplayName}
        </span>
      </div>

      <div className="flex">
        {displayNames?.secondaryDisplayName ? (
          <span className="w-[10rem] max-w-fit flex-auto truncate text-gray-600">
            {displayNames.secondaryDisplayName}
          </span>
        ) : null}
      </div>
    </>
  );
};
